import { useState } from 'react';
import { Outlet } from 'react-router';
import { SupplierTermsRouteGate } from '../legal/supplier-terms-access';
import { useSupplierTermsAccess } from '../../hooks/useSupplierTermsAccess';

import { EnvironmentRibbon } from '@accio3d/shared-ui/components/ui/environment-ribbon';

import { AppSidebar } from './app-sidebar';
import { AgentLayout } from './agent-layout';
import { GlobalTopBar } from './global-top-bar';
import { useAgentShortcuts } from '../../hooks/useAgentSidebar';
import { OrganizationPickerModal } from './organization-picker-modal';
import { PAGE_SHELL } from './page-shell';

/** Keeps opportunity and assistant content unloaded until supplier acceptance. */
export function AppLayout() {
  const [modalOpen, setModalOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const { terms } = useSupplierTermsAccess();

  useAgentShortcuts();

  return (
    <>
      <EnvironmentRibbon />
      <div className="flex h-screen overflow-hidden">
        <AppSidebar
          collapsed={collapsed}
          onExpand={() => setCollapsed(false)}
          onOpenOrgModal={() => setModalOpen(true)}
        />
        {terms.hasAccepted ? (
          <AgentLayout collapsed={collapsed} onToggleCollapsed={() => setCollapsed((c) => !c)} />
        ) : (
          <div className="flex min-w-0 flex-1 flex-col">
            <GlobalTopBar collapsed={collapsed} onToggleCollapsed={() => setCollapsed((c) => !c)} />
            <main className="min-w-0 flex-1 overflow-y-auto">
              <div className={PAGE_SHELL}>
                <SupplierTermsRouteGate>
                  <Outlet />
                </SupplierTermsRouteGate>
              </div>
            </main>
          </div>
        )}

        <OrganizationPickerModal open={modalOpen} onOpenChange={setModalOpen} />
      </div>
    </>
  );
}
